import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const COOKIE_KEY = 'sendbox_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') return;
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, [location.pathname]);

  const accept = (all) => {
    localStorage.setItem(COOKIE_KEY, JSON.stringify({ accepted: all, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[100] w-80 animate-in slide-in-from-bottom-4 duration-500" data-testid="cookie-banner">
      <div className="bg-slate-900/95 backdrop-blur-xl border border-blue-500/20 rounded-2xl p-5 shadow-2xl shadow-black/40">
        <div className="flex items-start justify-between mb-2">
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-blue-400" />
            <h3 className="text-white font-semibold text-sm">Vie privee</h3>
          </div>
          <button onClick={() => accept(false)} className="text-blue-300/40 hover:text-blue-300 transition-colors" data-testid="cookie-close">
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-blue-200/60 text-xs leading-relaxed mb-3">
          SENDBOX utilise des cookies essentiels et analytiques. Donnees stockees en France/Europe (RGPD).{' '}
          <Link to="/page/mentions-legales" className="text-blue-400 hover:text-blue-300 underline underline-offset-2">En savoir plus</Link>
        </p>
        <div className="flex gap-2">
          <button onClick={() => accept(true)} className="flex-1 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600 text-white text-xs font-medium rounded-lg transition-all" data-testid="cookie-accept-all">
            Tout accepter
          </button>
          <button onClick={() => accept(false)} className="flex-1 px-3 py-1.5 bg-slate-800 hover:bg-slate-700 border border-blue-500/20 text-blue-200/80 text-xs font-medium rounded-lg transition-all" data-testid="cookie-accept-essential">
            Essentiels
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
